import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const calendarContainerCss = "cwrk99d";
const CalendarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(calendarContainerCss, props.className)} />;
});
const navigatorWrapperIsPhoneCss = "nkkae0y";
const navigatorWrapperCss = "n1crztrm";
const NavigatorWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(navigatorWrapperCss, {
    [navigatorWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const titleContainerIsPhoneCss = "t1aplgm2";
const titleContainerCss = "thb06vr";
const TitleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(titleContainerCss, {
    [titleContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const containerIsPhoneCss = "ccro04w";
const containerCss = "c4j8atz";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const cardIsPhoneCss = "c66w7dv";
const cardCss = "c1r5ybn0";
const Card = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(cardCss, {
    [cardIsPhoneCss]: isPhone
  }, props.className)} />;
});
const footerIsPhoneCss = "f1hg4tg8";
const footerCss = "f1buqcpy";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export { Card, Footer, Container, NavigatorWrapper, TitleContainer, CalendarContainer };

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");